import React, { Fragment } from "react";

import Footer from "./Footer";
import Header from "./Header";

const ThemeWrapper = (props) => {
  return (
    <Fragment>
      <Header nameClass="backgorund-color-header" />
      <div className="page-container">
        <div className="page-content">{props.children}</div>
        <Footer />
      </div>
    </Fragment>
  );
};

export default ThemeWrapper;
